import { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import ExtensionIcon from '@material-ui/icons/Extension';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import { Code, LibraryBooks, OpenInNew, Help, Autorenew } from "@material-ui/icons"
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="catalog" text="Home" />
        <MyGroupsSidebarItem
          singularTitle="My Group"
          pluralTitle="My Groups"
          icon={GroupIcon}
        />
        <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
        <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
        <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
        <SidebarItem icon={Autorenew} to="pulse-hub" text="Pulse Hub" />
        {/* End global nav */}
        <SidebarDivider />

        <SidebarGroup icon={<Code />} label="Ferramentas">
          <SidebarItem icon={OpenInNew} to="https://us3.datadoghq.com/apm/home" target='_blank' text="Datadog" />
          <SidebarItem icon={OpenInNew} to="https://argocd.gmsuite.com.br" target='_blank' text="Argo GMSuite" />
          <SidebarItem icon={OpenInNew} to="https://argocd.infra.mateus" target='_blank' text="Argo OnPremise" />
          <SidebarItem icon={OpenInNew} to="https://sonarcloud.io/projects" target='_blank' text="SonarCloud" />
          <SidebarItem icon={OpenInNew} to="https://sonar.grupomateus.com.br" target='_blank' text="SonarQube" />
          <SidebarItem icon={OpenInNew} to="https://sonar-community.grupomateus.com.br" target='_blank' text="SonarQube Legado" />
          <SidebarItem icon={OpenInNew} to="https://confluent.cloud/environments/env-ym5yjk/clusters/lkc-3rv312/overview?granularity=PT1M&interval=3600000&label=Last%20hour" target='_blank' text="Confluent.io" />
          <SidebarItem icon={OpenInNew} to="https://hasura.gmsuite.com.br" target='_blank' text="Hasura" />
          <SidebarItem icon={OpenInNew} to="https://n8n.gmsuite.com.br" target='_blank' text="N8N" />
          <SidebarItem icon={Help} to="https://grupomateus.atlassian.net/servicedesk/customer/portal/16" target='_blank' text="Abrir Chamado" />
        </SidebarGroup>
        <SidebarSpace />

        <SidebarScrollWrapper>
          {/* Items in this group will be scrollable if they run out of space */}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
